import { render, staticRenderFns } from "./app-shop-basket.vue?vue&type=template&id=8eb1a4ae&scoped=true&"
import script from "./app-shop-basket.vue?vue&type=script&lang=js&"
export * from "./app-shop-basket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb1a4ae",
  null
  
)

export default component.exports